import React from "react";
import Select from "react-select";

const CountryDropdown = ({ options, selectedCountry, setSelectedCountry }) => {
  const formattedOptions = options.map((country) => ({
    ...country,
    countryName: country.label,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={`https://flagcdn.com/w20/${country.value.toLowerCase()}.png`}
          alt={country.label}
          style={{ width: "20px", height: "14px", borderRadius: "2px" }}
        />
        {country.label}
      </div>
    ),
  }));

  return (
    <div className="form-group">
      <label htmlFor="signup-country" className="form-label">
        Country
      </label>
      <Select
        id="signup-country"
        options={formattedOptions}
        value={selectedCountry}
        onChange={(selected) => setSelectedCountry(selected)} 
        isSearchable
        placeholder="Select Country"
        styles={{
          indicatorSeparator: () => ({ display: "none" }),
          control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? "black" : "#ccc",
            boxShadow: "none",
            fontFamily: '"Rajdhani", sans-serif',
            fontWeight: 600,
            fontSize: "16px",
            "&:hover": { borderColor: "black" },
          }),
          menu: (base) => ({
            ...base,
            fontWeight: 600,
            fontSize: "16px",
          }),
          option: (base) => ({
            ...base,
            fontWeight: 600,
            fontSize: "16px",
            fontFamily: '"Rajdhani", sans-serif',
            "&:hover": { backgroundColor: "var(--color-orange)", color: "var(--color-white)" },
          }),
        }}
      />
    </div>
  );
};

export default CountryDropdown;
